// extracted by mini-css-extract-plugin
export default {"mainContainer":"_3ue94dKMQyHtMP_zD2rlUX","container":"_1av2GlKdIYqyHg0eynx9Uj","text":"_3fpF0oEeu1sT5YNxWt1TCV","title":"_2lrtSAoNUpYOewA7fYdvqx","button":"_2Lj68mkypCdnKFeWI9Hxyu"};